import React from "react";
import { Route, Switch } from "react-router";
import HomeContainer from "../container/HomeContainer";
import FooterContainer from "../container/FooterContainer";
import HeaderContainer from "../container/HeaderContainer";
import Cookies from "./Cookies";
import { GERMAN } from "../actions/language";
import { LanguageContext } from "../context/LanguageContext";
import { connect } from "react-redux";
import {PlatformContext} from "../context/PlatformContext";
import {MAINTENANCE} from "../env";
import {DESKTOP} from "../actions/mobile";
import PlatformService from "../functional/PlatformService";

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            language: window.localStorage.getItem('language') || GERMAN,
            platform: window.localStorage.getItem('platform') || DESKTOP,
        };
        this.setLanguage = this.setLanguage.bind(this);
        this.setPlatform = this.setPlatform.bind(this);
    }

    // Method to update language
    setLanguage(newLanguage) {
        this.setState({ language: newLanguage });
        window.localStorage.setItem('language', newLanguage);
    }

    setPlatform(newPlatform) {
        this.setState({ platform: newPlatform });
        window.localStorage.setItem('platform', newPlatform);
    }

    render() {
        const { language, platform } = this.state;

        return (
            <PlatformContext.Provider value={{ platform , setPlatform: this.setPlatform}}>
                <LanguageContext.Provider value={{ language, setLanguage: this.setLanguage }}>
                    <div>
                        <PlatformService />
                        {
                            MAINTENANCE === false ?
                                <div>
                                    <link rel="stylesheet" href="/css/app.css"/>
                                    <link rel="stylesheet" href="/css/custom.style.css"/>
                                    <HeaderContainer />
                                    <div id="general-background-color">
                                        <Switch>
                                            <Route path="/" component={HomeContainer}/>
                                        </Switch>
                                    </div>
                                    <Cookies />
                                    <FooterContainer/>
                                </div> :
                                <div>
                                    {
                                        platform === DESKTOP ?
                                            <center>
                                                <img
                                                    src="/img/maintenance-page.png"
                                                    style={{height: "280px", width: "480px"}}
                                                />
                                            </center> : <center className="pt-4">
                                                <img
                                                    src="/img/maintenance-page.png"
                                                    style={{height: "180px", width: "340px"}}
                                                />
                                            </center>
                                    }
                                </div>
                        }
                    </div>
                </LanguageContext.Provider>
            </PlatformContext.Provider>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/components/App.js